import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExceldataService {


  private messageSource = new BehaviorSubject(['']);
  currentMessage = this.messageSource.asObservable();
  constructor() { 
   // this.changeMessage([]);
  }

  changeMessage(message: any[]) {
    
    console.log("my data",message)
     this.messageSource.next(message)
   
  }
}
